import React from 'react';
import { Link } from "react-router-dom";
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="vb-footer">
      <div className="vb-footer-top">
        <div className="container">
          <div className="vb-footer-grid">

            {/* Brand */}
            <div className="vb-footer-col vb-footer-brand">
              <div className="vb-footer-logo">
                <span className="vb-footer-logo-icon">♥</span>
                VivahBandh
              </div>
              <p className="vb-footer-tagline">
                India's trusted matrimony service helping hearts find their perfect match across communities.
              </p>
              <div className="vb-footer-social">
                <a href="https://facebook.com" className="vb-social-btn" target="_blank" rel="noreferrer" aria-label="Facebook">
                  <i className="ti ti-facebook"></i>
                </a>
                <a href="https://instagram.com" className="vb-social-btn" target="_blank" rel="noreferrer" aria-label="Instagram">
                  <i className="ti ti-instagram"></i>
                </a>
                <a href="https://twitter.com" className="vb-social-btn" target="_blank" rel="noreferrer" aria-label="Twitter">
                  <i className="ti ti-twitter-alt"></i>
                </a>
                <a href="https://youtube.com" className="vb-social-btn" target="_blank" rel="noreferrer" aria-label="YouTube">
                  <i className="ti ti-youtube"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="vb-footer-col">
              <h4 className="vb-footer-heading">Quick Links</h4>
              <ul className="vb-footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/discover">Discover Matches</Link></li>
                <li><Link to="/search">Search Profiles</Link></li>
                <li><Link to="/my-profile">My Profile</Link></li>
                <li><Link to="/favourite">Favourites</Link></li>
                <li><Link to="/request">Interests</Link></li>
              </ul>
            </div>

            {/* Legal */}
            <div className="vb-footer-col">
              <h4 className="vb-footer-heading">Company</h4>
              <ul className="vb-footer-links">
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/terms-conditions">Terms &amp; Conditions</Link></li>
                <li><Link to="/cancellation-refund">Cancellation &amp; Refund</Link></li>
                <li>
                  <a href="mailto:rpvivavahbandh@gmail.com">
                    <i className="ti ti-email"></i>
                    <span>
                      <span className="vb-footer-contact-label">Email Us</span>
                      <span className="vb-footer-contact-email">rpvivavahbandh@gmail.com</span>
                    </span>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      <div className="vb-footer-bottom">
        <div className="container">
          <div className="vb-footer-bottom-inner">
            <span>© {year} VivahBandh.com. All rights reserved.</span>
            <span className="vb-footer-made">Made with <span className="vb-footer-heart">♥</span> in India</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
